{
  "brand": "VBB PLAY",
  "tagline": "Премиальная игровая платформа",
  "loading": "Загрузка…",
  "retry": "Повторить",
  "close": "Закрыть",
  "search": "Поиск",
  "seeAll": "Смотреть все",
  "comingSoon": "Скоро",
  "currency": "AZN",
  "language": "Язык",
  "selectLanguage": "Выберите язык",
  "offlineHint": "Проверка соединения",
  "footerRights": "© {{year}} VBB PLAY. Все права защищены.",
  "footerSupport": "Поддержка",
  "heroEyebrow": "PLAY BEYOND LIMITS",
  "heroTitle": "Крупные игры, смелые выигрыши",
  "heroSubtitle": "Играйте без границ — премиальное лобби, защищённая касса и избранный каталог.",
  "heroCta": "Играть сейчас",
  "promoFallbackTitle": "Приветственный бонус",
  "promoFallbackSubtitle": "Бонусная и VIP-программа готовятся. Забирайте офферы, когда кампании появятся.",
  "promoFallbackCta": "Забрать",
  "promoFilter_all": "Все",
  "promoFilter_welcome": "Welcome",
  "promoFilter_casino": "Казино",
  "promoFilter_sports": "Спорт",
  "promoFilter_vip": "VIP",
  "login": "Вход",
  "storyBonuses": "Бонусы",
  "storyVip": "VIP",
  "storyCashback": "Кэшбэк",
  "storyCrypto": "Крипто",
  "bonusSelectTitle": "Выберите бонус",
  "continue": "Продолжить",
  "supportWelcome": "Добро пожаловать в VBB PLAY",
  "supportPrechat": "Перед началом диалога укажите контакты и вопрос.",
  "supportEmail": "Email",
  "supportName": "Имя",
  "supportMessage": "Сообщение",
  "supportConsent": "Согласен на обработку персональных данных.",
  "startDialogue": "Начать диалог",
  "attach": "Вложение",
  "send": "Отправить",
  "support247": "Поддержка 24/7",
  "supportInvite": "Операторы готовы помочь.",
  "contactSupport": "Связаться с поддержкой",
  "infoSection": "Информация",
  "referral": "Рефералы",
  "liveSports": "Лайв",
  "prematch": "Прематч",
  "fiatMethods": "Фиат",
  "fiatMethodsHint": "Карта, M10, Терминал",
  "cryptoMethodsHint": "Криптовалюты, доступные в кассе",
  "personalInfo": "Личные данные",
  "contactInfo": "Контакты",
  "displayName": "Имя",
  "notAvailable": "Недоступно",
  "phone": "Телефон",
  "profileEditHint": "Имя, дата рождения и пол хранятся в аккаунте.",
  "myProfile": "Мой профиль",
  "securitySettings": "Безопасность",
  "rewardCenter": "Центр наград",
  "notificationsTitle": "Уведомления",
  "markAllRead": "Отметить все прочитанными",
  "marketingOptIn": "Получать промо-уведомления",
  "emptyNotifications": "Нет уведомлений",
  "notificationsUnavailable": "Событийные уведомления появляются здесь. Ничего не выдумывается.",
  "open": "Открыть",
  "protectionTitle": "Защита аккаунта",
  "coolingOff": "Период охлаждения",
  "selfExclude": "Самоисключение",
  "requestClosure": "Запросить закрытие аккаунта",
  "helpSupport": "Помощь и поддержка",
  "promoCode": "Промокод",
  "redeem": "Активировать",
  "bonusHistory": "История бонусов",
  "promoLoginRequired": "Войдите, чтобы активировать код.",
  "promoSuccess": "Начислено {{amount}} AZN",
  "promo_invalid_code": "Этот код недействителен.",
  "promo_campaign_expired": "Срок акции истёк.",
  "promo_campaign_inactive": "Акция неактивна.",
  "promo_campaign_not_started": "Акция ещё не началась.",
  "promo_per_user_limit": "Вы уже использовали этот код.",
  "promo_unique_user_limit": "Лимит игроков по акции исчерпан.",
  "promo_usage_limit": "Активации по этой акции закончились.",
  "promo_not_eligible": "Вы не подходите под условия акции.",
  "promo_minimum_deposit_not_satisfied": "Требуется квалифицирующий депозит.",
  "promo_budget_exhausted": "Бюджет акции исчерпан.",
  "promo_too_many_requests": "Слишком много попыток. Попробуйте позже.",
  "promo_zero_reward": "У этой акции нет денежной награды здесь.",
  "promo_redeem_failed": "Не удалось активировать код.",
  "storyPromo": "Промокод",
  "liveSupport": "Онлайн-поддержка",
  "sportsUnavailable": "Ставки на спорт пока недоступны. Казино работает.",
  "linked": "Подключено",
  "notLinked": "Не подключено",
  "loadFailed": "Не удалось загрузить",
  "unavailableTitle": "Недоступно",
  "vipUnavailable": "VIP-уровни ещё не настроены.",
  "givenName": "Имя",
  "familyName": "Фамилия",
  "dateOfBirth": "Дата рождения",
  "gender": "Пол",
  "genderMale": "Мужчина",
  "genderFemale": "Женщина",
  "genderOther": "Другое",
  "genderPreferNot": "Предпочитаю не указывать",
  "saveProfile": "Сохранить профиль",
  "profileSaved": "Профиль сохранён",
  "profileSaveFailed": "Не удалось сохранить профиль",
  "identityLockedNotice": "Ваши личные данные сохранены. Для изменения обратитесь в живую поддержку.",
  "identityChangeRequest": "Запросить изменение",
  "identityChangeReason": "Причина изменения",
  "identitySubmitRequest": "Отправить запрос",
  "identityChangePending": "Ваш запрос на рассмотрении.",
  "identityChangeSubmitted": "Запрос отправлен. Живая поддержка свяжется с вами.",
  "identityChangeFailed": "Не удалось отправить запрос.",
  "identityNoChanges": "Нет изменений для запроса.",
  "createdAt": "Аккаунт создан",
  "ageIneligible": "Эта дата рождения ниже допустимого возраста. Реальные деньги остаются отключены.",
  "rateOperator": "Оцените диалог",
  "ratingComment": "Комментарий (необязательно)",
  "submitRating": "Отправить оценку",
  "ratingThanks": "Спасибо за оценку",
  "footerRules": "Правила",
  "footerPrivacy": "Конфиденциальность",
  "rulesLink": "Правила и политики",
  "footerLegalTitle": "Юридическая информация",
  "footerLegalDraftBadge": "ЧЕРНОВИК",
  "footerLegalDraftNotice": "Указанные реквизиты приведены только как локальный юридический черновик. До подтверждения регистрации компании и лицензии не утверждается, что эти данные проверены, что VBB PLAY имеет лицензию или полномочия на законное осуществление всей игорной деятельности.",
  "footerCompanyLabel": "Компания",
  "footerCompanyName": "Vbb Play Byte Lab Sociedad de Responsabilidad Limitada",
  "footerCountryLabel": "Страна регистрации",
  "footerCountryValue": "Коста-Рика",
  "footerRegNumberLabel": "Регистрационный номер",
  "footerRegNumberValue": "2-101-918934",
  "footerAddressLabel": "Юридический адрес",
  "footerAddressValue": "Provincia 04 San Jose, Canton 02 Escazu, San Rafael, в 200 метрах к югу от кинотеатров Multiplaza de Escazu, Seiba street, Centro Corporativo EBC, 10-й этаж, офис Invicta Legal.",
  "footerLicenseNumberLabel": "Представленный номер лицензии",
  "footerLicenseNumberValue": "ALSI-207508070-FI1",
  "footerLicenseJurisdictionLabel": "Представленная юрисдикция лицензии",
  "footerLicenseJurisdictionValue": "Анжуан, Союз Коморских Островов",
  "footerLegalAria": "Юридическая информация",
  "footerLegalStatement": "© 2026 VBB Play. vbbplay.com Kosta-Rikada qeydiyyatdan keçmiş Vbb PLay Byte Lab Sociedad de Responsabilidad Limitada şirkətinə məxsusdur və onun tərəfindən idarə olunur, qeydiyyat nömrəsi 2-101-918934, hüquqi ünvanı: Provincia 04 San Jose, Canton 02 Escazu, San Rafael, Multiplaza de Escazu kinoteatrlarından 200 metr cənubda, Seiba küçəsi, Centro Corporativo EBC, onuncu mərtəbə, Invicta Legal ofisi. vbbplay.com Komor Adaları İttifaqının Avtonom Anjuan Adası Hökuməti tərəfindən lisenziyalaşdırılıb və tənzimlənir və ALSI-207508070-FI1 nömrəli lisenziya əsasında fəaliyyət göstərir. VbbPlay.com bütün tənzimləyici tələblərdən keçmişdir və hər cür qumar oyunları və mərc əməliyyatlarını qanuni şəkildə həyata keçirməyə səlahiyyətlidir.",
  "back": "Назад",
  "rulesSelectAria": "Выберите юридический документ",
  "scrollToTop": "Наверх",
  "footerAria": "Подвал сайта",
  "footerLiveCasino": "Живое казино",
  "footerProviders": "Провайдеры",
  "footerFastGames": "Быстрые игры",
  "footerEsports": "Киберспорт",
  "footerTournaments": "Турниры",
  "footerPartnership": "Партнёрская программа",
  "footerTechSupport": "Техподдержка",
  "footerSupportSecurity": "Поддержка и безопасность",
  "footerSocial": "Соцсети",
  "footerSocialPending": "Официальные соцсети появятся здесь после подтверждения.",
  "footerAgeHint": "Только 18+",
  "footerLegalAccordionTitle": "Юридическая информация"
}
